<template>
  <div
    class="loader-container"
    :class="variant"
    v-if="msg">
    <div v-if="typeof msg === 'string'" class="msg">{{msg}}</div>
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  props: [
    'msg',
    'variant',
  ],
  name: 'loader',
};
</script>

<style lang="scss">
.loader-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 2;
  overflow: hidden;
  cursor: progress;
  color: white;

  .loader,
  .loader:after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }

  .loader {
    position: absolute;
    top: calc(50% - 9em);
    left: calc(50% - 5em);
    font-size: 10px;
    text-indent: -9999em;
    border-top: 1.1em solid rgba(255, 255, 255, 0.2);
    border-right: 1.1em solid rgba(255, 255, 255, 0.2);
    border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
    border-left: 1.1em solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }

  &.light {
    background: rgba(255,255,255,0.7);
    color: #333333;

    .loader {
      border-top: 1.1em solid rgba(0, 0, 0, 0.4);
      border-right: 1.1em solid rgba(0, 0, 0, 0.4);
      border-bottom: 1.1em solid rgba(0, 0, 0, 0.4);
      border-left: 1.1em solid #333333;
    }
  }

  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .msg {
    position: absolute;
    width: 100%;
    top: calc(50% + 2em);
    text-align: center;
  }
}
</style>
